import { MAX_TERM_COUNT, SequenceMode, SequenceSeriesRange } from './sequence-series.model';

export function computeSequenceTerms(
  mode: SequenceMode,
  firstTerm: number,
  commonFactor: number,
  range: SequenceSeriesRange,
): number[] {
  const count = Math.min(range.to - range.from + 1, MAX_TERM_COUNT);
  const terms: number[] = [];

  for (let i = 0; i < count; i++) {
    const n = range.from + i;
    if (mode === 'arithmetic') {
      terms.push(firstTerm + (n - 1) * commonFactor);
    } else {
      terms.push(firstTerm * Math.pow(commonFactor, n - 1));
    }
  }

  return terms;
}

export function computeSeriesPartialSums(terms: number[]): number[] {
  const sums: number[] = [];
  let runningSum = 0;

  for (const term of terms) {
    runningSum += term;
    sums.push(runningSum);
  }

  return sums;
}
